module.exports = __webpack_public_path__ + "static/stickermule-476f4b478c36be0f7563ecbca53023d7.png";